module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-8.f60a9ed4.svg";